
import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter, namespace } from "vuex-class";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { AreaNote } from "@/store/area-notes/types";
import AreaNotesTableItem from "@/components/area-notes/AreaNotesTableItem.vue";
import { UserPermissions } from "@/store/types";

const AreaNotes = namespace("areaNotes");

@Component({
	components: {
		"vue-perfect-scrollbar": VuePerfectScrollbar,
		"area-notes-table-item": AreaNotesTableItem
	}
})
export default class AreaNotesTable extends Vue {
	@Prop({ type: Boolean, default: false}) isDataLoading: boolean;
	@Prop({ type: Boolean, default: false}) showOnlyNotesToAcknowledge: boolean;
	@Prop({ type: Boolean, default: false}) hideUpdateControls: boolean;
	
	@AreaNotes.Getter getAreaNotes: AreaNote[];
	@AreaNotes.Getter getIsFormShown: number;;
	@Getter getPermissions: UserPermissions;

	private get areaNotes(): AreaNote[] {
		let notesToShow: AreaNote[] = this.getAreaNotes;

		if (this.showOnlyNotesToAcknowledge == true) {
			notesToShow = notesToShow.filter(n => n.requiresAcknowledgement === true);
		}
		return notesToShow;
	}

	private hasPermissonsToEditNotes(): boolean {
		return this.getPermissions.canViewSiteSetup;
	}
}
